/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-08 17:04:12
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-16 15:36:36
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/Title/index.tsx
 */
import React from 'react';

import { Icon } from '@/src/tools/icon';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

type Props = {
  title: JSX.Element | string;
  leftElement?: JSX.Element | string;
  //   middleElement: JSX.Element | string;
  rightElement?: JSX.Element | string;
  totalCount?: number;
  onBack?: (e: any) => void;
};

function Title({
  title,
  leftElement,
  rightElement,
  totalCount,
  onBack,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        {leftElement ? (
          leftElement
        ) : (
          <span onClick={onBack}>
            <Icon type='iconback' className={styles.icon} />
            <span>{getI18n('general.back')}</span>
          </span>
        )}
      </div>
      <div className={styles.middle}>{title}</div>
      <div className={styles.right}>
        {rightElement ? (
          rightElement
        ) : (
          <span>{`${totalCount} ${getI18n(
            'general.linkModule.Components.Head.items',
          )}`}</span>
        )}
      </div>
    </div>
  );
}

export default Title;
